import * as types from './constants';

export const getAiPromptSuggestionsRequest = () => ({
  type: types.GET_AI_PROMPT_SUGGESTIONS_REQUEST,
  payload: {}
});

export const getAiPromptSuggestionsDone = data => ({
  type: types.GET_AI_PROMPT_SUGGESTIONS_DONE,
  payload: data
});

export const getAiPromptSuggestionsFailed = errors => ({
  type: types.GET_AI_PROMPT_SUGGESTIONS_FAILED,
  payload: errors
});

export const setSuggestionsToDisplay = suggestionsType => ({
  type: types.SET_SUGGESTIONS_TO_DISPLAY,
  payload: suggestionsType
});
